<template>
  <div class="row m-0">
    <div class="col-12 p-3 mt-3 card dropshadow">
      <a
        class
        href
        role="button"
        id="checkout-order-summary"
        aria-controls="collapseExample"
        @click.prevent="orderSummary"
        data-test="orderSummaryLink"
      >
        <h4
          class="m-0"
          id="checkout-order-summary-heading"
          data-test="orderSummaryHead"
        >2. Order Summary</h4>
      </a>
      <div class="collapse order-summary-collapse" id="collapse-summary">
        <div class="row pt-3 m-0">
          <!--<cart-list-->
          <!--:cartProducts="getBuyNowProduct"-->
          <!--:removeButton="false"-->
          <!--v-if="getBuyNowProduct.length > 0"-->
          <!--&gt;-->
          <!--</cart-list>-->
          <!--<cart-list-->
          <!--:cartProducts="getCartProducts"-->
          <!--:removeButton="true"-->
          <!--v-else-->
          <!--&gt;-->
          <!--</cart-list>-->
          <!--<cart-summary-container :continueShopping="false">-->
          <!--</cart-summary-container>-->
          <!--<cart :buttonShow="false"></cart>-->
          <cart-container
            :productsData="getBuyNowProduct"
            :productCount="getBuyNowProductCount"
            :totalPrice="getBuyNowTotal"
            :totalCartPrice="getBuyNowItemTotal"
            :totalOffer="getBuyNowOffer"
            v-if="getBuyNowProductCount > 0"
          ></cart-container>
          <cart-container
            :productsData="getCartProducts"
            :productCount="getCartCount"
            :totalPrice="getcartTotal"
            :totalCartPrice="getcartItemTotal"
            :totalOffer="getcartTotalOffer"
            v-else
          ></cart-container>
        </div>
        <!-- <hr class=""> -->
        <!--<apply-gift-card-form @giftCardValidate="giftCardNumberValidate($event)"></apply-gift-card-form>-->
        <!--Exclude feature: Redeem Coin-->

        <!--<apply-coins-form @coinValidate="coinValidate($event)">-->
        <!--</apply-coins-form>-->

        <!--Exclude feature: Redeem Coin-->
        <!-- order summery mobile tab view -->
        <!-- <div class="row m-0">
          <div class="col-12 p-0 wp_paddingTopContainer wp_hideItOnDesktop">
            <div class="wp_ContainerCartSummery">
              <div class="wp_CartSummerySideBarConatiner">
                <cart-summary
                  :cartCount="getBuyNowProductCount"
                  :cartTotal="getBuyNowTotal"
                  :cartItemsTotal="getBuyNowItemTotal"
                  :cartTotalOffer="getBuyNowOffer"
                  v-if="getBuyNowProductCount > 0"
                ></cart-summary>
                <cart-summary
                  :cartCount="getCartCount"
                  :cartTotal="getcartTotal"
                  :cartItemsTotal="getcartItemTotal"
                  :cartTotalOffer="getcartTotalOffer"
                  v-else
                ></cart-summary>
              </div>
            </div>
          </div>
        </div> -->
        <!-- order summery mobile tab view -->

        <div class="row m-0 mt-4">
          <div class="col-12 col-md-12">
            <p
              class="d-block d-md-inline"
              style="display: inline;"
              data-test="orderSummaryConfirmationPara"
              id="orderSummaryConfirmationPara"
            >
              Order confirmation email will be sent to
              <span
                class="email-block"
                data-test="orderSummaryConfirmationEmail"
                id="orderSummaryConfirmationEmail"
              >{{getUserData.email}}</span>
            </p>
            <form class="needs-validation" novalidate style="display: inline;float: right;">
              <button
                type="button"
                name
                id="checkout-order-summary-continue-button"
                class="btn btn-primary blue-btn"
                @click.prevent="continueToPayment"
                data-test="orderSummaryContinueBtn"
              >Continue</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { orderApi } from '@/services/ApiServices/orderApi'
import CartContainer from '@/components/pages/cart/cartContainer/CartContainer'
// import ApplyGiftCardForm from '../forms/ApplyGiftCardForm'
// import CartSummary from '@/components/pages/cart/cartContainer/cartSummary/CartSummary'
// import CartProducts from '@/components/widgets/cart/CartProducts';
// import CartSummaryContainer from '@/components/widgets/cart/CartSummaryContainer';
// import CartList from '@/components/widgets/cart/CartList';
// import Cart from '../../cart/Cart';

export default {
	props: {
		step: {
			type: Number,
			default: 0
		}
	},
	data () {
		return {
			total: 0,
			coinDiscount: 0,
			coinValue: 0,
			coinNo: 0
		}
	},
	computed: {
		...mapGetters('cart', [
			'getCartProducts',
			'getCartCount',
			'getcartTotal',
			'getcartItemTotal',
			'getcartTotalOffer'
		]),
		...mapGetters('buynow', [
			'getBuyNowProduct',
			'getBuyNowProductCount',
			'getBuyNowTotal',
			'getBuyNowItemTotal',
			'getBuyNowOffer'
		]),
		...mapGetters('user', ['getUserData']),
		...mapGetters('siteData', ['getLoyaltyRules'])
	},
	components: {
		// ApplyGiftCardForm,
		CartContainer
		// CartSummary
		// CartSummaryContainer,
		// CartList,
	},
	methods: {
		...mapActions('user', [
			'setGiftAmountData',
			'setGiftCardNo',
			'setGiftCardPin',
			'setCoinRedeemValue'
		]),
		...mapActions('buynow', ['updateGiftCardQuantity', 'updateCoinAmount']),
		...mapActions('cart', [
			'updateGiftCardCartQuantity',
			'updateCartCoinAmount'
		]),
		...mapActions('charges', ['setShowCharge']),
		async continueToPayment () {
			if (
				(this.getCartProducts && this.getCartProducts.length > 0) ||
        (this.getBuyNowProduct && this.getBuyNowProduct.length > 0)
			) {
				await orderApi.orderProduct()
				this.setShowCharge(true)
				$('#collapse-summary').collapse('hide')
				$('#collapse-payment').collapse('show')
				this.$emit('toPayment')
			} else {
				this.$router.push('/')
			}
		},
		orderSummary () {
			this.setShowCharge(false)
			if (this.step >= 2) {
				$('#collapse-address').collapse('hide')
				$('#collapse-summary').collapse('show')
				$('#collapse-payment').collapse('hide')
			}
			// else {
			//   Vue.toasted.error(' You cannot go to payment option at this stage. ',
			// { icon: 'exclamation-circle' });
			// }
		}
		// giftCardNumberValidate (cardData) {
		// 	this.setGiftCardNo(cardData.giftCardNumber)
		// 	this.setGiftCardPin(cardData.giftCardPin)
		// 	orderApi
		// 		.giftCardValidate(cardData)
		// 		.then(res => {
		// 			this.setGiftAmountData(res.data)
		// 			this.updateGiftCardQuantity()
		// 			this.updateGiftCardCartQuantity()
		// 		})
		// 		.catch(e => {
		// 			this.clearGiftCardNo()
		// 			this.clearGiftCardPin()
		// 		})
		// }
		// coinValidate (coinNo) {
		// 	this.coinNo = coinNo
		// 	this.coinValue = this.getLoyaltyRules.value_of_one_coin * coinNo

		// 	if (this.getBuyNowProductCount > 0) {
		// 		this.total = this.getBuyNowTotal
		// 	} else {
		// 		this.total = this.getcartTotal
		// 	}
		// 	this.discount =
		// this.total * (this.getLoyaltyRules.redeem_limit_percentage / 100)
		// 	this.coinDiscount = Math.trunc(this.discount)

		// 	if (this.coinDiscount >= this.coinValue) {
		// 		const data = {
		// 			coinValue: this.coinValue,
		// 			coinNo: this.coinNo
		// 		}
		// 		this.setCoinRedeemValue(data)
		// 		// store.dispatch('user/setCoinRedeemValue', this.coinValue);
		// 	} else {
		// 		const data = {
		// 			coinValue: this.coinDiscount,
		// 			coinNo: this.coinNo
		// 		}
		// 		this.setCoinRedeemValue(data)
		// 		// store.dispatch('user/setCoinRedeemValue', this.coinDiscount);
		// 	}
		// 	this.updateCartCoinAmount()
		// 	this.updateCoinAmount()
		// }
	}
}
</script>
